<template>
  <div class="container-fluid p-5" style="margin-top: 50px; margin-bottom: 80px">
    <TableHeader title="Mis Proveedores" buttonText="CREAR PROVEEDOR" routeName="create-additive-provider" />

    <div class="d-flex align-items-center">
      <div class="d-flex justify-content-between gap-2 w-25" style="border: 2px solid black; border-radius: 5px 0 0 0; padding: 5px; background: black">
        <n-input placeholder="Buscar proveedores" v-model:value="searchBar" @keyup.enter="this.getProviders(this.searchBar, this.filter)">
          <template #suffix>
            <i class="icon-remove-circle input-icon" @click="this.cleanSearch"></i>
          </template>
        </n-input>
      </div>
      <div style="padding: 5px; border: 2px solid black; background: black">
        <n-button class="filter-button" @click="openFilterModal">
          <i class="icon-filter" style="color: white"></i>
        </n-button>
      </div>
      <div style="padding: 5px; border: 2px solid black; background: black; border-top-right-radius: 8px">
        <n-button secondary type="info" @click="this.getProviders(this.searchBar, this.filter)" style="background: white"> Buscar</n-button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead class="table-head-dark">
          <tr>
            <th scope="col" class="text-sm" @click="this.sortColumn('name')">
              Nombre
              <i v-if="this.selectedColumn === 'name'" :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>
            <th scope="col" class="text-sm" @click="this.sortColumn('contact')">
              Contacto
              <i v-if="this.selectedColumn === 'contact'" :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>
            <th scope="col" class="text-sm" @click="this.sortColumn('location')">
              Ubicación
              <i v-if="this.selectedColumn === 'location'" :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>
            <th scope="col" class="text-sm" @click="this.sortColumn('email')">
              Correo electrónico
              <i v-if="this.selectedColumn === 'email'" :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>
            <th scope="col" class="text-sm" @click="this.sortColumn('phone')">
              Teléfono
              <i v-if="this.selectedColumn === 'phone'" :class="this.sortDirection ? 'icon-angle-down' : 'icon-angle-up'"></i>
            </th>
            <th scope="col" class="text-sm">Tipo</th>
            <th scope="col" class="text-align text-sm">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr scope="row" v-if="this.loading" style="width: 50vw; height: 2rem">
            <td colspan="7">
              <div class="d-flex justify-content-center">
                <div class="spinner-border" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
            </td>
          </tr>
          <tr scope="row" v-if="!this.loading && this.providers.length === 0" style="width: 50vw; height: 2rem">
            <td colspan="7" class="text-center">
              <n-p>No se encontraron resultados...</n-p>
            </td>
          </tr>
          <tr v-else-if="!this.loading && this.providers.length > 0" v-for="(provider, index) in providers" :key="index">
            <td scope="row" class="align-middle text-sm">{{ provider.name }}</td>
            <td scope="row" class="align-middle text-sm">{{ provider.contact }}</td>
            <td scope="row" class="align-middle text-sm">{{ provider.location }}</td>
            <td scope="row" class="align-middle text-sm">{{ provider.email }}</td>
            <td scope="row" class="align-middle text-sm">{{ provider.phone }}</td>
            <td scope="row" class="align-middle text-sm">
              <n-button strong secondary round type="success" size="tiny" v-for="type in provider.type">{{ checkType(type) }} </n-button>
            </td>

            <td scope="row" class="align-middle">
              <n-tooltip trigger="hover">
                <template #trigger>
                  <router-link :to="{ name: 'edit-provider', params: { id: provider._id } }" style="text-decoration: none; color: inherit">
                    <i class="icon-edit" style="padding-right: 12px" />
                  </router-link>
                </template>
                Editar
              </n-tooltip>
              <n-tooltip trigger="hover">
                <template #trigger>
                  <i class="icon-copy" style="padding-right: 12px; cursor: pointer" @click="cloneProvider(provider)" />
                </template>
                Clonar
              </n-tooltip>
              <n-tooltip trigger="hover">
                <template #trigger>
                  <span @click="handleConfirm(provider)" style="cursor: pointer; padding-bottom: 4px; padding-right: 12px">
                    <i class="icon-trash" />
                  </span>
                </template>
                Eliminar
              </n-tooltip>
              <n-tooltip trigger="hover" v-if="provider.extra.length > 0">
                <template #trigger>
                  <span type="info" size="large" @click="extraModal(provider)" style="cursor: pointer; padding-bottom: 4px">
                    <i class="icon-comment" />
                  </span>
                </template>
                Notas
              </n-tooltip>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-around pb-1 g-2 mt-2">
      <n-button type="info" size="medium" style="font-size: 20px" @click="this.goToPreviousPage" v-show="this.page > 1"> &lt; Pagina anterior </n-button>
      <span type="info" size="medium" style="font-size: 20px" v-show="this.page - 1 === 0"> </span>
      <n-p>Página {{ this.page }} de {{ this.numberOfPages }}</n-p>
      <n-button type="info" quaternary size="medium" style="font-size: 20px" @click="this.goToNextPage" :disabled="this.providers.length < 25">
        Pagina siguiente &gt;
      </n-button>
    </div>
    <!-- extra data modal -->
    <n-modal v-model:show="showExtraModal">
      <n-card style="width: 600px" title="Notas" :bordered="false" size="huge" role="dialog" aria-modal="true">
        <n-space vertical>
          <div v-for="(extra, index) in currentProvider.extra" :key="index">
            <li>{{ extra.extra }}</li>
          </div>
        </n-space>
      </n-card>
    </n-modal>
    <n-modal v-model:show="filterModal">
      <n-card style="width: 75vw" title="Filtros" :bordered="false" size="huge" role="dialog" aria-modal="true">
        <n-checkbox-group v-model:value="filter">
          <n-space item-style="display: flex;" align="center" justify="space-between" class="gap-2">
            <n-checkbox value="fertilizer" label="Fertilizantes" />
            <n-checkbox value="phytosanitary" label="Fitosanitarios" />
            <n-checkbox value="fertilizerAndPhytosanitary" label="Fertilizantes + Fitosanitarios" />
            <n-checkbox value="additive" label="Aditivos" />
            <n-checkbox value="gasoil" label="Gasoil" />
            <n-checkbox value="seed" label="Semillas" />
          </n-space>
          <div class="d-flex justify-content-center align-items-center w-100 mt-4">
            <n-button @click="closeFilterModal">Aplicar filtros</n-button>
          </div>
        </n-checkbox-group>
      </n-card>
    </n-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useMessage, useDialog } from "naive-ui";
import providerStore from "../../store/provider";
import authStore from "../../store/auth";
import TableHeader from "../../components/tableHeader.vue";

export default {
  data() {
    return {
      message: useMessage(),
      dialog: useDialog(),
      showExtraModal: false,
      filterModal: false,
      currentProvider: "",
      selectedColumn: "",
      searchBar: "",
      filter: [],
    };
  },
  computed: {
    ...mapState(providerStore, ["providers", "sortDirection", "page", "numberOfPages", "loading"]),
    ...mapState(authStore, ["isLoggedIn"]),
  },
  methods: {
    ...mapActions(providerStore, [
      "getAllProviders",
      "removeProvider",
      "updateProvider",
      "sortProviders",
      "searchProviders",
      "getProviders",
      "goToNextPage",
      "goToPreviousPage",
      "createProvider",
    ]),
    async cloneProvider(provider) {
      try {
        const { contact, email, extra, location, phone, type } = provider;
        let data = {
          contact,
          email,
          extra,
          location,
          phone,
          type,
          name: `${provider.name} (copia)`,
        };
        await this.createProvider(data);
        this.message.success("Proveedor clonado");
        // await this.getProviders(this.searchBar);
      } catch (e) {
        throw e;
      }
    },
    cleanSearch() {
      this.searchBar = "";
      this.filter = [];
      this.getProviders();
    },
    sortColumn(key) {
      this.sortProviders(key);
      this.selectedColumn = key;
    },
    openFilterModal() {
      this.filterModal = true;
    },
    closeFilterModal() {
      this.getProviders(this.searchBar, this.filter);
      this.filterModal = false;
    },
    checkType(type) {
      if (type === "gasoil") {
        return "Gasoil";
      } else {
      }
      if (type === "additive") {
        return "Aditivos";
      }
      if (type === "fertilizer") {
        return "Fertilizante";
      }
      if (type === "fertilizerAndPhytosanitary") {
        return "Fertilizantes + Fitosanitarios";
      }
      if (type === "seed") {
        return "Semillas";
      }
      if (type === "phytosanitary") {
        return "Fitosanitarios";
      }
    },
    handleConfirm(provider) {
      this.dialog.warning({
        title: "Confirmar",
        content: "Esta seguro que desea eliminar el proveedor?",
        positiveText: "ACEPTAR",
        negativeText: "CANCELAR",
        onPositiveClick: () => {
          this.deleteProvider(provider._id);
        },
        onNegativeClick: () => {
          this.message.error("Acción cancelada");
        },
      });
    },
    deleteProvider(id) {
      this.removeProvider(id);
    },
    extraModal(provider) {
      this.showExtraModal = true;
      this.currentProvider = provider;
    },
  },
  async mounted() {
    if (!this.isLoggedIn) {
      this.message.info("Necesitas iniciar sesión para acceder a esta dirección", { duration: 5000 });
      this.$router.push("/app/login");
    }
    await this.getProviders(this.searchBar);
  },
  components: { TableHeader },
};
</script>

<style scoped>
.filter-button {
  color: var(--white);
}
.list-border {
  border-bottom: 1px solid var(--black);
}

.row-collapse-color1 {
  background-color: var(--white);
}

.row-collapse-color2 {
  background-color: var(--white);
}

.table-head-dark {
  background-color: var(--black);
  color: var(--white);
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
}
.table-border {
  border: solid var(--black) 2px;
}
</style>
